/*--------------------------------------------------------------
# Custom scripts for Vertical tabs block
--------------------------------------------------------------*/

document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.nav-pills').forEach(function(navPillsContainer) {
        const hasBuyTab = navPillsContainer.querySelector('.vertical-tabs-buy') !== null;
        const tabIndex = hasBuyTab ? 3 : 2;

        const tabButton = navPillsContainer.querySelector(`button:nth-child(${tabIndex})`);
        if (tabButton) {
            const tabTargetSelector = tabButton.getAttribute('data-bs-target');
            const tabPane = document.querySelector(tabTargetSelector);

            // Remove .active and .show from all .tab-pane siblings
            const allTabPanes = tabPane?.closest('.tab-content')?.querySelectorAll('.tab-pane');
            if (allTabPanes) {
                allTabPanes.forEach(pane => {
                    pane.classList.remove('active', 'show');
                });
            }

            // Add .active and .show to the target tab pane
            if (tabPane) {
                tabPane.classList.add('active', 'show');
            }

            // Show the tab using Bootstrap API
            const tab = new bootstrap.Tab(tabButton);
            tab.show();

            // Update the mobile dropdown toggle text
            const newText = tabButton.textContent.trim();
            const dropdownToggle = navPillsContainer.closest('.dropdown-menu')?.previousElementSibling;
            if (dropdownToggle && dropdownToggle.classList.contains('dropdown-toggle')) {
                dropdownToggle.textContent = newText;
            }
        }
    });
});


// refresh slick slider when tabs are shown so it gets the correct height
jQuery('button[data-bs-toggle="pill"]').on('shown.bs.tab', function (e) {
    // jQuery('.tab-content .blog-reel-slider').slick('setPosition');

    const target = jQuery(e.target).attr("data-bs-target"); // Get the target tab content ID
    const pillPaneSlickSliders = jQuery(target).find('.slick-slider'); // Find Slick slider in the tab content

    if (pillPaneSlickSliders.length) { // Check if Slick slider exists
        pillPaneSlickSliders.slick('setPosition');
    }
});

// on click of dropdown item replace mobile dropdown toggle with selected item
jQuery('.nav-pills button').on('click', function(){
    const selectedNavpillText = jQuery(this).text();
    jQuery(this).closest('.dropdown-menu').prev('.dropdown-toggle').text(selectedNavpillText);
});


/* 
Actions for the links under tabs.
*/
// Instructional Videos
jQuery('.inst-vid-link').on('click', function(e){
    // Get the tab name - should match the name of this link
    var tabname = ( jQuery('.inst-vid-link span.ms-2').text() );

    // Select the videos tab.
    const verticalNavPills = document.querySelectorAll('.nav-tabs button[data-text="' + tabname + '"]');

    // Now activate that tab.
    verticalNavPills.forEach(function(secondVerticalTabTriggerEl) {
        const secondVerticalTab = new bootstrap.Tab(secondVerticalTabTriggerEl);       
        // Show it.
        secondVerticalTab.show();
    });
    return true;
});
// Related Products
jQuery('.rel-prods').on('click', function(e){
    // Get the tab name - should match the name of this link
    var tabname = ( jQuery('.rel-prods span.ms-2').text() );

    // Select the videos tab.
    const verticalNavPills = document.querySelectorAll('.nav-tabs button[data-text="' + tabname + '"]');

    // Now activate that tab.
    verticalNavPills.forEach(function(secondVerticalTabTriggerEl) {
        const secondVerticalTab = new bootstrap.Tab(secondVerticalTabTriggerEl);       
        // Show it.
        secondVerticalTab.show();
    });
    return true;
});
// Materials & Downloads
jQuery('.mat-downs').on('click', function(e){
    // Get the tab name - should match the name of this link
    tabname = ( jQuery('.mat-downs span.ms-2').text() );

    // Select the videos tab.
    const verticalNavPills = document.querySelectorAll('.nav-tabs button[data-text="' + tabname + '"]');

    // Now activate that tab.
    verticalNavPills.forEach(function(secondVerticalTabTriggerEl) {
        const secondVerticalTab = new bootstrap.Tab(secondVerticalTabTriggerEl);       
        // Show it.
        secondVerticalTab.show();
    });
    return true;
});